$(document).ready(function () {
  $(".col-banner_dropdown-select--js").click(function () {
    var newTitle = $(this).attr("data-title");
    var newColor = $(this).attr("data-color");
    var newIcon = $(this).attr("data-icon");
    var newCollection = $(this).attr("data");

    $(".col-banner_dropdown_selection").find("p").html(newTitle);
    $(".col-banner_dropdown_selection").find("p").css("color", newColor);
    $(".col-banner_dropdown_selection").find(".mainImg").attr("src", newIcon);
    $(".col-banner_dropdown_selection").css("border", "1px solid " + newColor);
    $(".col-banner_dropdown-selection-menu").slideToggle();

    var handle = $(this).attr("data");
    applyFilter(handle);
  });

  $(".col-banner_dropdown_selection").click(function () {
    $(this).toggleClass("active");
    $(".col-banner_dropdown-selection-menu").slideToggle();
  });

  function applyFilter(handle) {
    var showAll = !handle || handle === "all-products";
    $(".collection-products_card_outer").each(function () {
      var raw = $(this).attr("data-collections") || "";
      var tokens = "--" + raw + "--";
      if (showAll || tokens.indexOf("--" + handle + "--") !== -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  $(".col-banner_nav-btn").on("click", function () {
    $(".col-banner_nav-btn").removeClass("active");
    $(this).addClass("active");
    var handle = $(this).attr("data");
    applyFilter(handle);
  });

  function closePopup() {
    $(".collection-banner-video_popup").fadeOut();
    $(".collection-banner_video_box video").each(function () {
      this.pause();
      this.currentTime = 0;
      $(this).prop("muted", true);
    });
  }

  $(".collection-banner-arrow_next").click(function () {
    var $bubbles = $(".col-banner_video-bubble");
    var $activeBox = $(".collection-banner_video_box:visible");
    var currentId = $activeBox.data("id");
    var $currentBubble = $bubbles.filter('[data-id="' + currentId + '"]');
    var currentIndex = $bubbles.index($currentBubble);

    // compute next index (wrap to 0 if last)
    var nextIndex = (currentIndex + 1) % $bubbles.length;
    $bubbles.eq(nextIndex).trigger("click");
  });

  $(".collection-banner-arrow_prev").click(function () {
    var $bubbles = $(".col-banner_video-bubble");
    var $activeBox = $(".collection-banner_video_box:visible");
    var currentId = $activeBox.data("id");
    var $currentBubble = $bubbles.filter('[data-id="' + currentId + '"]');
    var currentIndex = $bubbles.index($currentBubble);

    // compute previous index (wrap to last if first)
    var prevIndex = (currentIndex - 1 + $bubbles.length) % $bubbles.length;
    $bubbles.eq(prevIndex).trigger("click");
  });

  $(".col-banner_video-bubble").on("click", function (e) {
    e.stopPropagation();
    var blockId = $(this).data("id");
    $(".collection-banner_video_box")
      .hide()
      .find("video")
      .each(function () {
        this.pause();
        this.currentTime = 0;
        $(this).prop("muted", true);
      });
    $(".collection-banner-video_popup").css("display", "flex");
    var $videoBox = $(
      '.collection-banner_video_box[data-id="' + blockId + '"]'
    );
    $videoBox.show();
    var $video = $videoBox.find("video");
    $video.prop("muted", false);
    $video.get(0).play();
  });

  $(".collection-banner_close").on("click", function () {
    closePopup();
  });

  $(".collection-banner-video_popup_inner").on("click", function (e) {
    e.stopPropagation();
  });

  $(".collection-banner-video_popup").on("click", function (e) {
    if ($(e.target).is(".collection-banner-video_popup")) {
      closePopup();
    }
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      closePopup();
    }
  });

  $(".collection-faq_block").click(function () {
    $(this).toggleClass("active");
    $(this).find(".collection-faq_content").slideToggle();
  });

  $(".collection-products_card_outer").click(function () {
    var nextUrl = $(this).attr("data-url");
    window.location.href = nextUrl;
  });
});
